import React, { useEffect } from 'react';

import { useCreateInvoiceContext } from 'packages/invoices/hooks/useCreateInvoice';
import { CreateInvoiceStepIndex } from 'packages/invoices/ui/create/CreateInvoiceHeaderWithTimelineStepper';
import { CreateInvoiceLineItems } from 'packages/invoices/ui/create/CreateInvoiceLineItems';

export const CreateInvoiceComponents = ({
  setCurrentStepIndex,
}: {
  setCurrentStepIndex: React.Dispatch<
    React.SetStateAction<CreateInvoiceStepIndex>
  >;
}) => {
  const {
    invoiceComponentsWithInvoiceItems,
    invoice,
    addInvoiceComponent,
  } = useCreateInvoiceContext();

  // this is a placeholder for now to automatically add an invoice component when reaching this step
  // once we build multi-invoice FE, we will remove this placeholder and add functionality to add / remove components
  useEffect(() => {
    if (invoiceComponentsWithInvoiceItems.length === 0) {
      addInvoiceComponent({
        invoiceComponentType: invoice.invoiceType,
        finleyLoanId: invoice.finleyLoanId,
        accrualStartDate: invoice.accrualStartDate,
        accrualEndDate: invoice.accrualEndDate,
        totalAmount: invoice.totalAmount,
      });
    }
  }, [invoiceComponentsWithInvoiceItems, invoice, addInvoiceComponent]);

  // @dani multi-invoice todo: add functionality to add / remove components

  return (
    <>
      {invoiceComponentsWithInvoiceItems.map((_invoiceComponent, idx) => {
        const key = idx;

        return (
          <CreateInvoiceLineItems
            key={key}
            setCurrentStepIndex={setCurrentStepIndex}
            invoiceComponentIndex={idx}
          />
        );
      })}
    </>
  );
};
